import IMG_1 from 'assets/images/apps/top.png'
import IMG_2 from 'assets/images/apps/m1.png'
import IMG_3 from 'assets/images/apps/m2.png'
import IMG_4 from 'assets/images/apps/img-badge-app-store.png'
import IMG_5 from 'assets/images/apps/img-badge-google-play.png'
import IMG_6 from 'assets/images/apps/l.svg'
import IMG_7 from 'assets/images/apps/r.svg'

import ApplicationAppSwiper from '../../components/swiper/ApplicationAppSwiper'
import './ApplicationMain.scss'

/**
 * @file 어플리케이션 main 화면
 */
function ApplicationMain() {
    return (
        <>
            <div className="application-one" style={{ backgroundImage: `url(${IMG_1})` }}>
                <div className="text-box">
                    {/* <div className="sub"></div> */}
                    <div className="t1">IQ 시스템</div>
                </div>
            </div>
            <div className="application-two">
                <div className="text-box">
                    <div className="t1">스마트 네트워크</div>
                    <div className="sub">
                        스마트 차량제어 시스템을 적용해
                        <br />
                        미래 지향적이고 편리한 서비스를 제공합니다.
                    </div>
                </div>
                <div className="text-box">
                    <div className="t1">IQ System</div>
                    <div className="sub">
                        미래 지향적인 IQ 시스템을 적용하여
                        <br />
                        지속적인 안전 모니터링, 성능 업데이트, 스마트 서비스 등을 제공합니다
                    </div>
                </div>
            </div>
            <div className="application-three">
                <div className="grid-box">
                    <div>
                        <div className="text-box">
                            <div className="t1">더 새롭고 직관적으로</div>
                            <div className="sub">
                                한 눈에 들어오는 인터페이스를 적용하여
                                <br />
                                차량을 쉽게 관리할 수 있습니다.
                            </div>
                        </div>
                    </div>
                    <div style={{ backgroundImage: `url(${IMG_2})` }} />
                    <div style={{ backgroundImage: `url(${IMG_3})` }} />
                    <div>
                        <div className="text-box">
                            <div className="t1">스마트 커넥트</div>
                            <div className="sub">
                                원격 네트워크 서비스가 탑재되어 먼 거리에서도 App을 통해 차량 상태 확인, 원격 잠금 해제,
                                차량 위치 수신이 가능합니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="application-four">
                <div className="title-box">
                    <div className="t1">App 하나면 충분합니다</div>
                    <div className="sub">
                        직관적인 UI와 스마트한 차량 제어 기능을 탑재한 App은 <br />
                        사용자의 스타일에 맞춰 주행을 쉽고 편리하게 만듭니다
                    </div>
                </div>
                <div className="apps">
                    <a href="">
                        <img src={IMG_4} alt="" />
                    </a>
                    <a href="">
                        <img src={IMG_5} alt="" />
                    </a>
                </div>
            </div>
            <div className="application-five">
                <div className="application-slide-wrap">
                    <button className="slide-control-btn prev">
                        <img src={IMG_6} alt="" />
                    </button>
                    <button className="slide-control-btn next">
                        <img src={IMG_7} alt="" />
                    </button>
                    <ApplicationAppSwiper />
                </div>
                <div className="swiper-pagination" />
            </div>
        </>
    )
}

export default ApplicationMain
